export const SPORTCALLER = 'sportcaller';
export const SPORTCALLER_IFRAME_CLASS = `${SPORTCALLER}__iframe`;
export const SPORTCALLER_IRELAND_COUNTRY = 'IRL';
export const SPORTCALLER_IRELAND_LOGOUT = '/ie/logout';
export const SPORTCALLER_LOGOUT = '/logout';
export const SPORTCALLER_TOKEN_URL = '/sportcaller/getCustomerToken/';
export const SPORTCALLER_NOT_AVAILABLE_I18N_KEY = 'sportcaller.not_available';
export const SPORTCALLER_SLUG = '10kdrive';
export const SPORTCALLER_TOURNAMENT_URL = 'sportcaller/getTournamentId';
export const SPORTCALLER_SPORT_SLUG = 'american-football';
export const SPORTCALLER_CATEGORY_SLUG = 'united-states-of-america';
export const SPORTCALLER_TOURNAMENT_SLUG = 'nfl';
